module.exports = __webpack_public_path__ + "static/media/BM7100-59H_02.c48a80ae.png";